/* Generated public navigation; no private upstream addresses. */
export const services = [
  {
    "label": "Foundry",
    "url": "https://foundry.galaxylost.com/"
  },
  {
    "label": "Overseerr",
    "url": "https://overseer.galaxylost.com/"
  }
] as const;
